module.exports = __webpack_public_path__ + "static/media/intro.075341e4.mp3";